var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_6815)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_762_6815)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_762_6815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 54C41.9117 54 54 41.9117 54 27C54 12.0883 41.9117 0 27 0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54Z",
    fill: "#6900FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.741 16H37.672C38.3983 16.0021 39.0943 16.2916 39.6078 16.8052C40.1214 17.3187 40.4109 18.0147 40.413 18.741V35.19C40.4109 35.9163 40.1214 36.6123 39.6078 37.1258C39.0943 37.6394 38.3983 37.9289 37.672 37.931H15.741C15.0147 37.9289 14.3187 37.6394 13.8052 37.1258C13.2916 36.6123 13.0021 35.9163 13 35.19V18.741C13.0021 18.0147 13.2916 17.3187 13.8052 16.8052C14.3187 16.2916 15.0147 16.0021 15.741 16Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.414 18.7412L26.707 28.3362L13 18.7412",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_6815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_762_6815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_762_6815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0a176c72fa9a4d727c1bf9088eda52b5.svg";
export { ForwardRef as ReactComponent };